import { StringKeyDictionary } from "../commonInterfaces.js";
import { AdditionalData } from "../core/components/commonApp.js";
import {
    BaseColumn,
    EditableGrid,
    EditableGridProps,
    field,
    InGridButtonClickParams,
    InGridToolBarButton,
    Schema,
    ValidationResult,
    ValidationResultType
} from "../core/components/editableGrid/editableGrid.js";
import { ValidationBuilder } from "../core/components/editableGrid/validationBuilder.js";
import { ToolBarInGridButtonType } from "../core/components/toolBar.js";
import { CashExpensesHelper } from "../core/util/cashExpensesHelper.js";
import { Helper } from "../core/util/helper.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { Baraus } from "../generalSettings/serviceReport/cashExpense.js";
import { CashExpenseEntity, TravelReportEntity } from "./travelReportInterfaces.js";
import React from "react";
export class TravelReportCashExpensesInGrid extends React.Component<CashExpenseGridProps, CashExpenseGridState>{
    editableGridRef: EditableGrid;

    constructor(props: any) {
        super(props);
        this.state = {
            CuFactors: null
        };
    }

    componentDidMount() {
        this.getCuFactors();
    }

    private getCuFactors = async () => {
        let cuFactors = await HTTPService.get<any[]>("InvoiceLookup/GetCuFaktor");
        this.setState({ CuFactors: cuFactors });
    }

    private getFactor = (currency: string) => {
        let cuFactor = this.state.CuFactors.find(x => x.Currency == currency);
        let factor = cuFactor?.Faktor ?? 1;
        return factor;
    }

    private getCashExpense = async (nr: number, idBaraus: number): Promise<Baraus> => {
        let result = await HTTPService.get<JsonResultClass<Baraus>>("CashExpenses/GetCashExpense", { nr: nr, idBaraus: idBaraus });
        return result.Data;
    }

    private resolveAdditionalData = async (newValue: any, fieldName: string, fullObject: any, options: any) => {
        switch (fieldName) {
            case "TypKey":
                let cashExpenseVm = await this.getCashExpense(newValue, this.props.entity.IdBaraus);
                if (!Helper.hasValue(options.model?.Currency)) {
                    let currency = cashExpenseVm?.CurrencyId ?? options.model.Currency ?? this.props.entity.TargetCurrency.Currency;
                    this.setCurrency(currency, options.model);
                }
                this.setBarausValues(options.model, cashExpenseVm);
                this.calculateAndSetValues(options.model);
                options.model.set("TypKey_additional_data", { Description: cashExpenseVm?.Description });
                let schlusselAdditionalData: AdditionalData = { Description: cashExpenseVm?.Description ?? "" };
                return schlusselAdditionalData;
        }
    }

    private flag: boolean = false;
    onCashExpensesGridDataChanged = async (action: string, fieldName: string, dataItems: any) => {
        if (action == "itemchange" && !this.flag) {
            this.itemChangeHandle(fieldName, dataItems);
            this.flag = false;
        }
        this.props.onChange();
    }

    private async itemChangeHandle(fieldName: string, dataItems: any) {
        let changedDataItem = dataItems[0];
        this.flag = true;
        let dataItem: CashExpenseEntity = changedDataItem;
        switch (fieldName) {
            case "Date":
                changedDataItem.set("WeekDay", kendo.toString(kendo.parseDate(changedDataItem.Date), "ddd"));
                break;
            case "Quantity":
            case "Value":
                this.calculateAndSetValues(dataItem);
                break;
            case "Factor":
                let tmpSumFactor = CashExpensesHelper.getSumInCurrency(dataItem.Sum, dataItem.Factor);
                changedDataItem.set("SumInCurrency", tmpSumFactor);
                break;
            case "Currency":
                this.setCurrency(dataItem.Currency, changedDataItem);
                let tmpSumCurrency = CashExpensesHelper.getSumInCurrency(dataItem.Sum, dataItem.Factor);
                changedDataItem.set("SumInCurrency", tmpSumCurrency);
                this.editableGridRef.refreshColumnTemplate(changedDataItem, "Value");
                this.editableGridRef.refreshColumnTemplate(changedDataItem, "Expenses");
                this.editableGridRef.refreshColumnTemplate(changedDataItem, "Invoice");
                this.editableGridRef.refreshColumnTemplate(changedDataItem, "Sum");
                break;
        }
    }

    private setCurrency = (currency: string, changedDataItem: any) => {
        let factor = 1;
        let symbol;
        if (Helper.hasValue(this.props.entity.ConvertToTargetCurrencies)) {
            let cuFaktor = this.props.entity.ConvertToTargetCurrencies.find(x => x.Currency == currency);
            factor = cuFaktor?.Factor;
            symbol = cuFaktor?.Characters;
        }
        changedDataItem.set("Currency", currency);
        changedDataItem.set("Factor", factor);
        changedDataItem.set("CurrencySymbol", symbol);
    }

    private setBarausValues(changedDataItem: any, cashExpenseVm: Baraus) {
        changedDataItem.set("Typ", cashExpenseVm?.OriginalDescription);
        if (!Helper.hasValue(changedDataItem.Quantity))
            changedDataItem.set("Quantity", cashExpenseVm?.Quantity ?? 1);
        if (!Helper.hasValue(changedDataItem.Value))
            changedDataItem.set("Value", cashExpenseVm?.Amount ?? 1);
        if (!Helper.hasValue(changedDataItem.CostFactor))
            changedDataItem.set("CostFactor", cashExpenseVm?.CostFactor);
        if (!Helper.hasValue(changedDataItem.ExpensesAmount))
            changedDataItem.set("ExpensesAmount", cashExpenseVm?.ExpensesAmount);
        if (!Helper.hasValue(changedDataItem.InvoiceFactor))
            changedDataItem.set("InvoiceFactor", cashExpenseVm?.InvoiceFactor);
        if (!Helper.hasValue(changedDataItem.InvoiceAmount))
            changedDataItem.set("InvoiceAmount", cashExpenseVm?.InvoiceAmount);
        changedDataItem.set("ZeroAmount", cashExpenseVm?.ZeroAmount);
        changedDataItem.set("LockAmount", cashExpenseVm?.LockAmount);
        changedDataItem.set("LockQuantity", cashExpenseVm?.LockQuantity);
    }

    private calculateAndSetValues = (dataItem: any) => {
        let sum = CashExpensesHelper.getSum(dataItem.Quantity, dataItem.Value);
        let sumInCurrency = CashExpensesHelper.getSumInCurrency(sum, dataItem.Factor);
        let expenses = CashExpensesHelper.getExpenses(dataItem.Quantity, dataItem.Value, dataItem?.CostFactor, dataItem?.ExpensesAmount);
        let invoice = CashExpensesHelper.getInvoice(dataItem.Quantity, dataItem.Value, dataItem?.InvoiceFactor, dataItem?.InvoiceAmount);
        dataItem.set("Sum", sum);
        dataItem.set("SumInCurrency", sumInCurrency);
        dataItem.set("Expenses", expenses);
        dataItem.set("Invoice", invoice);
    }

    private createNewDataItem = (dataSource: kendo.data.DataSource) => {
        let cashExpenses = (dataSource.data() as any) as CashExpenseEntity[];
        let date = kendo.parseDate(kendo.toString(this.props.entity.Start, "d"));
        let newCashExpense = {
            Date: date,
            WeekDay: kendo.toString(date, "ddd"),
            Currency: "EUR",
            Factor: this.getFactor("EUR"),
            PIndex: 1,
            IsNew: true
        } as CashExpenseEntity;
        newCashExpense.IndividualFields = {};

        if (cashExpenses.length > 0) {
            let cashExpenseBefore: CashExpenseEntity = cashExpenses[cashExpenses.length - 1];
            newCashExpense.PIndex = cashExpenses.filter(x => Helper.hasValue(x.PIndex)).reduce((prev, current) => (prev.PIndex > current.PIndex) ? prev : current).PIndex + 1;
            newCashExpense.Date = cashExpenseBefore.Date;
            newCashExpense.WeekDay = cashExpenseBefore.WeekDay;
            newCashExpense.Currency = cashExpenseBefore.Currency;
            newCashExpense.Factor = cashExpenseBefore.Factor;
        }

        newCashExpense.HasBarausRef = true;
        newCashExpense.IsBarausDeleted = false;

        return newCashExpense;
    }

    onRequestItemValidation = (columns: BaseColumn[], dataItem: CashExpenseEntity): ValidationResult => {
        let start = kendo.parseDate(kendo.toString(this.props.entity.Start, "d"));
        let end = kendo.parseDate(kendo.toString(this.props.entity.End, "d"));
        var allowZeroAmount = Helper.hasValue(dataItem.ZeroAmount) && dataItem.ZeroAmount == 1;

        return new ValidationBuilder()
            .checkReqiredFields(columns, dataItem)
            .addWarning(Helper.hasValue(dataItem.Date) && (dataItem.Date < start || dataItem.Date > end), Helper.getTranslation("Standard.DatumAusserhalb"))
            .addWarning(!dataItem.HasBarausRef, Helper.getTranslation("Field.Barauslage.LinkedCashExpenseMissing"))
            .addWarning(dataItem.HasBarausRef && dataItem.IsBarausDeleted, Helper.getTranslation("Field.Barauslage.LinkedCashExpenseDeleted"))
            .addError(!Helper.hasValue(dataItem.Quantity) || (!allowZeroAmount && dataItem.Quantity <= 0),
                Helper.getTranslation("Validierung.FeldMussEinenWertHaben").replace("{Field}", Helper.getTranslation("Field.Barauslage.tkk")))
            .addError(!Helper.hasValue(dataItem.Value) || (!allowZeroAmount && dataItem.Value <= 0),
                Helper.getTranslation("Validierung.FeldMussEinenWertHaben").replace("{Field}", Helper.getTranslation("Standard.Value")))
            .addError(!Helper.hasValue(dataItem.Factor) || (!allowZeroAmount && dataItem.Factor <= 0),
                Helper.getTranslation("Validierung.FeldMussEinenWertHaben").replace("{Field}", Helper.getTranslation("Field.Barauslage.faktor")))
            .build();
    }

    handleButtonClick = (p: InGridButtonClickParams) => {
        switch (p.id) {
            case "new":
                let entity = this.createNewDataItem(p.dataSource);
                p.actions.add(entity);
                break;
            case "edit":
                p.actions.editSelected();
                break;
            case "delete":
                p.actions.deleteSelected(true);
                break;
        }
    }

    render() {
        let editable = this.props.entity.RecordRight.CanWrite;

        const buttons: Array<InGridToolBarButton> = [];
        buttons.push({ type: ToolBarInGridButtonType.NEW, id: "new" });
        buttons.push({ type: ToolBarInGridButtonType.EDIT, id: "edit", enabled: (p) => this.props.entity.RecordRight.CanWrite && p.hasSingleSelection });
        buttons.push({ type: ToolBarInGridButtonType.DELETE, id: "delete" });

        let schema = new Schema();
        schema.Id = "PIndex";
        schema.fields["PIndex"] = new field("number");
        return <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <EditableGrid id="trCashExpenses"
                editable={editable}
                data={this.props.data}
                gridOptions={this.props.gridOptions}
                schema={schema}
                resolveAdditionalData={this.resolveAdditionalData}
                onDataChanged={this.onCashExpensesGridDataChanged}
                buttons={buttons}
                onButtonClick={this.handleButtonClick}
                ref={(ref) => this.editableGridRef = ref}
                onRequestItemValidation={this.onRequestItemValidation}
                gridDetails={{
                    useFeature: true
                }}
                useFloatingButtons={true}
                {...this.props}
            />
        </div>
    }
}

export interface CashExpenseGridProps extends EditableGridProps{
    entity: TravelReportEntity;
    data: CashExpenseEntity[];
    gridOptions: any;
    dataSources: any;
    translations: StringKeyDictionary<string>;
    onChange?: () => void;
}

export interface CashExpenseGridState {
    CuFactors: any[];
}